<template>
  <div class="con">
    <!-- <div class="banner">
            <img  :src="`http://www.icoolglobal.cn/${info.picurl}`" alt="">
        </div> -->
    <div class="main">
      <div class="links wow fadeInUp">
        <a href="./index.html" target="_self">{{ $t("techInfo").text0 }}</a>
        <i class="el-icon-arrow-right"></i>
        <a href="./tech.html" target="_self">{{ $t("techInfo").text1 }}</a>
        <i class="el-icon-arrow-right"></i>
        <a @click="goto">{{ info.title }}</a>
      </div>
      <div class="title wow fadeInUp">
        {{ info.title }}
      </div>
      <!-- <div class="time wow fadeInUp">
              {{info.posttime}}
          </div> -->
      <div class="content">
        <div class="html" v-html="info.content"></div>
        <div class="right">
          <img :src="`http://www.icoolglobal.cn/${info.picurl}`" alt="" />
        </div>
      </div>

      <!-- <div class="pager">
               <div class="l wow fadeInLeft" @click="gotoNext(prev.id)">
                   <i class="el-icon-arrow-left" ></i>
                   <span>{{prev.title}}</span>
               </div>
              <div class="l wow fadeInRight" @click="gotoNext(next.id)">
                  <span>{{next.title}}</span>
                  <i class="el-icon-arrow-right" ></i>
              </div>
          </div> -->
    </div>
    <foot-Component class="foot wow fadeIn"></foot-Component>
  </div>
</template>

<script>
import { getNewsPage } from "../util/lang";
import footComponent from "../components/foot";
import Scrollbar from "smooth-scrollbar";
export default {
  name: "newsInfo",
  data() {
    return {
      text: "",
      info: {},
      prev: {},
      next: {},
    };
  },
  components: { footComponent },
  mounted() {
    Scrollbar.initAll(document.getElementById("scroller-wrapper"));
    this.$nextTick(() => {
      this.getNewsInfo();
      if (this.getNid2() == "12") {
        this.text = this.$t("top").tList[0];
      } else if (this.getNid2() == "13") {
        this.text = this.$t("top").tList[1];
      } else if (this.getNid2() == "14") {
        this.text = this.$t("top").tList[2];
      } else {
        this.text = this.$t("top").tList[3];
      }
    });
  },
  methods: {
    goto() {
      const link = `./news.html?index=${this.getNid2()}`;
      window.open(link, "_self");
    },
    gotoInfo(id) {
      const link = `/newsInfo.html?id=${id}`;
      window.open(link, "_self");
    },
    getNid() {
      return window.location.search
        .replace("?", "")
        .split("?")[0]
        .split("=")[1];
    },
    getNid2() {
      return window.location.search.replace("?", "").split("=")[2];
    },
    getNewsInfo() {
      const nid = this.getNid();
      const url = `${getNewsPage(nid)}`;
      this.$axios.get(url).then((res) => {
        this.info = res.data.news;
        // console.log(res)
      });
    },
    gotoNext(id) {
      if (id) {
        const link = "/newsInfo.html?id=" + id;
        window.open(link, "_self");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.con {
  width: 100%;
  .banner {
    width: 100%;
    position: relative;
    overflow: hidden;
    overflow: hidden;
    img {
      display: block;
      // height: 488px;
      width: 100%;
      object-fit: cover;
      animation: sbig 5s linear forwards;
    }
    @keyframes sbig {
      from {
        transform: scale(1);
        // filter: blur(5px);
      }
      to {
        transform: scale(1.05);
        // filter: blur(0);
      }
    }
  }
  .main {
    width: 77%;
    margin: 0 auto;
    margin-bottom: 60px;
    padding-top: 140px;
    .links {
      width: 100%;
      animation-duration: 2s;
      a {
        color: #666666;
        font-family: "SOURCEHANSANSCN-NORMAL";
        transition: all 600ms;
        cursor: pointer;
        &:hover {
          color: #019bdb;
        }
      }
      i {
        display: inline-block;
        margin: 0 5px;
      }
      a:last-child {
        color: #019bdb;
      }
    }
    .title {
      color: #333333;
      font-size: 38px;
      font-family: "SOURCEHANSANSCN-BOLD";
      text-align: center;
      margin-top: 60px;
    }
    .time {
      color: #9a9a9a;
      font-family: "SOURCEHANSANSCN-BOLD";
      padding: 20px 0;
      text-align: center;
      border-bottom: 1px solid rgba(220, 220, 220, 0.4);
    }
    .content {
      display: flex;
      justify-content: space-between;
        margin: 40px auto;
      .html {
        width: 48%;
        line-height: 30px;
      }
      .right{
          width: 48%;
          img{
              width: 100%;
          }
      }
    }

    .pager {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-top: 20px;
      position: relative;
      margin: 60px auto;
      .l {
        color: #343434;
        font-family: "SOURCEHANSANSCN-NORMAL";
        cursor: pointer;
        span {
          display: inline-block;
          transition: all 600ms;
        }
        &:hover {
          color: #0c4ea2;
        }
        i {
          display: inline-block;
          margin: 0 5px;
        }
      }
    }
  }
  .foot {
    animation-duration: 2s;
  }
  @keyframes transition1 {
    0% {
      transform: translate(-100px, -100px);
      opacity: 0;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(100px, -100px);
      opacity: 0;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes polygon {
    0% {
      clip-path: polygon(100% 0, 99% 50%, 50% 99%, 100% 50%);
      opacity: 0;
    }
    100% {
      clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
      opacity: 1;
    }
  }
  @media screen and (max-width: 1440px) {
    .main {
      width: 90%;
      .nav {
        width: 100%;
      }
    }
  }
  @media screen and (max-width: 1000px) {
    .banner {
      img {
        height: 300px;
      }
    }
    .main {
      padding-top: 70px;
      // margin: 30px auto;
      .title {
        font-size: 20px;
        margin-top: 30px;
      }
      .pager {
        .l {
          width: 40%;
          display: flex;
          flex-direction: row;
          align-items: center;
          span {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }
      }
      .content{
        flex-direction: column-reverse;
        margin: 30px auto;
        .html{
          width: 100%;
        }
        .right{
          width: 100%;
        }
      }
    }
  }
}
</style>
<style scoped>
.html >>> p {
  color: #333333;
  line-height: 30px !important;
}
.html >>> p a{
  color: #019bdb;
}
.pageC >>> p img {
  width: 100% !important;
  object-fit: cover;
}
.pageC >>> p video {
  width: 100%;
  object-fit: cover;
}
.pageC >>> div img {
  width: 100%;
  object-fit: cover;
}
</style>
